import { render, staticRenderFns } from "./ASorItemModule.vue?vue&type=template&id=b464592c"
import script from "./ASorItemModule.vue?vue&type=script&lang=js"
export * from "./ASorItemModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports